import { Text } from '@/ui-kit'
import { formatNumber } from '@/utils'
import { Star } from 'lucide-react'
import type { NectarProject } from '../api/models'

export const MissionProjectHeader = ({ project }: { project: NectarProject }) => {
  return (
    <div className="flex flex-col gap-2 border-b border-solid border-gray-100 pb-6">
      <Text type="h4">{project.name}</Text>
      {project.description && (
        <Text type="body1-regular" className="text-gray-80 mt-2 max-w-[880px]">
          {project.description}
        </Text>
      )}
      {!!project.rewardConfig?.amount && (
        <div className="text-gray-70 mt-4 flex items-start gap-2">
          <Star size={16} className="text-green mt-1 shrink-0" />
          Earn {formatNumber(project.rewardConfig.amount, 0)} points for completing this project
        </div>
      )}
    </div>
  )
}

